module.exports = __webpack_public_path__ + "ae0d0f75b2cb4d523df26250b3b384af.png";